import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

/**
 * PlatformService provides a centralized way to detect the current platform
 * (browser vs server) for SSR compatibility.
 * 
 * Use this service to conditionally execute browser-only code.
 */
@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Returns true if running in a browser environment
   */
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  /**
   * Returns true if running on the server (SSR)
   */
  isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  /**
   * Returns the platform ID (useful for debugging)
   */
  getPlatformId(): Object {
    return this.platformId;
  }
}

